var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshHeading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 25C6.37258 25 1 19.6274 1 13C1 6.37258 6.37258 1 13 1C19.6274 1 25 6.37258 25 13C25 19.6274 19.6274 25 13 25Z",
    fill: "#007CB0",
    stroke: "#007CB0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.293 7L14.1464 9.14645C13.9512 9.34171 13.9512 9.65829 14.1464 9.85355C14.32 10.0271 14.5894 10.0464 14.7843 9.91141L14.8536 9.85355L17.8536 6.85355C18.0271 6.67999 18.0464 6.41056 17.9114 6.21569L17.8536 6.14645L14.8536 3.14645C14.6583 2.95118 14.3417 2.95118 14.1464 3.14645C13.9729 3.32001 13.9536 3.58944 14.0886 3.78431L14.1464 3.85355L16.293 6H13C9.21455 6 6.1309 9.00478 6.00406 12.7593L6 13C6 16.866 9.13401 20 13 20C16.866 20 20 16.866 20 13C20 12.7239 19.7761 12.5 19.5 12.5C19.2239 12.5 19 12.7239 19 13C19 16.3137 16.3137 19 13 19C9.68629 19 7 16.3137 7 13C7 9.7616 9.56557 7.12243 12.7751 7.00414L13 7H16.293L14.1464 9.14645L16.293 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshHeading);
export default __webpack_public_path__ + "static/media/refresh-heading.b0d61302f30316fbb61420d57fd4d794.svg";
export { ForwardRef as ReactComponent };